<template>
  <div class="wrapper">
    <div class="check-sales-box" id="myElement" @click="goProgram">
      <img :src="checkSalesImgUrl1" alt="核销兑换流程1">
    </div>



    <div class="btn-box">
      <div class="copy" @click="copyClick">
        <div class="tips">复制去搜索</div>
      </div>
<!--      <a :href="jumpLink" v-if="jumpLink" class="sale-btn">点击跳转去核销</a>-->
    </div>

  </div>
</template>

<script>
import {getMiniprogramLink} from "../request/api";

export default {
  name: '',
  components: {
  },
  data () {
    return {
      checkSalesImgUrl1:'https://ssqs-1304047091.cos.ap-guangzhou.myqcloud.com/resource/share_exchange_001.jpg',
      windowsHeight:2196,
      jumpLink:"",
    }
  },


  created(){
  },
  mounted() {
    // 修改网页的标题
    document.title = "核销兑换流程";
    window.location.href = 'weixin://dl/business/?appid=wx5ae20db711a4359d&path=pages/layout/layout';
    getMiniprogramLink({}).then((res)=>{
      console.log(res,'查看返回的链接');
      this.jumpLink = res.data.url_link;
      if(res.data.url_link){
        // window.location.href = 'weixin://dl/business/?appid=wx5ae20db711a4359d&path=pages/layout/layout';
      }
    })
  },
  methods:{
    copyClick(){
      let copy_text = '送水骑士';//拿到想要复制的值
      let input_dom = document.createElement('input');//创建input元素
      input_dom.value = copy_text;//添加需要复制的内容到value属性
      document.body.appendChild(input_dom);//向页面底部追加输入框
      input_dom.select();//选择input元素
      document.execCommand("Copy");//执行复制命令
      alert("复制成功！");//弹出提示信息，不同组件可能存在写法不同
      input_dom.remove(); // 移除input元素
      // console.log('是否点击触发')
    },

    goProgram(){

      // 获取 User Agent
      let userAgent = navigator.userAgent.toLowerCase();
// 判断是否在微信中打开
      if (userAgent.indexOf('micromessenger') !== -1) {
        window.location.href = this.jumpLink;   //这里是微信浏览器打开
      } else {
        // console.log('当前页面不在微信中打开');
        window.location.href = 'weixin://dl/business/?appid=wx5ae20db711a4359d&path=pages/layout/layout';
      }

    }
  }
}
</script>

<style scoped lang="less">
  .wrapper{
    width: 100%;
    position: relative;
  }
  .check-sales-box{
    width: 100%;
    position: relative;
    img{
      width: 100%;
    }
    .guide-1{
      width: 60px;
      height: 60px;
      display: flex;
      font-size: 0;
      position: absolute;
      right: 60px;
      top: 1060px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .btn-box{
    width: 28%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    right: 20%;
    bottom: 9%;
    .copy{
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      background: #ffffff;
      padding: 4px;
      border-radius: 30px;
      font-size: 15px;
      border: 1px solid #cccccc;
      .label{
        color: #333333;
      }
      .line{
        width: 1px;
        height: 20px;
        margin: 0 10px;
        background: #999999;
      }
      .tips{
        color: #3E99F6;
        span{
          color:#999999;
        }
      }
    }
    .sale-btn{
      width: 55%;
      margin: 20px auto 0 auto;
      line-height: 50px;
      height: 50px;
      border: 3px solid #ffffff;
      background: #2771FE;
      color: #ffffff;
      font-size: 24px;
      text-align: center;;
      border-radius: 25px;
      padding: 0 10px;
      text-decoration: none;
      -webkit-animation: scale 1.2s ease-in-out infinite;
    }

    @-webkit-keyframes scale{
      0%, 100%{
        -webkit-transform: scale(1);
      }
      50%{
        -webkit-transform: scale(1.1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/exchange.vue